import React from 'react';
import PropTypes from 'prop-types';

import './CommonTabList.css';

const CommonTabList = ({ children, className }) => (
  <div className={`common-tab-list__component ${className}`}>
    {children}
  </div>
);

CommonTabList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.object]),
  className: PropTypes.string,
};
CommonTabList.defaultProps = {
  className: '',
};

export default CommonTabList;
